<template>
  <v-container>
    <div class="text-center pt-5">
      <br />
      <br />
      <div>読み込み中</div>
      <br />
      <div class="hollow-dots-spinner" style="margin:0 auto">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </v-container>
</template>
<style scoped>
.hollow-dots-spinner,
.hollow-dots-spinner * {
  box-sizing: border-box;
}

.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid black;
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: calc(300ms * 3);

}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
<script>
import axios from "axios";

export default {
  created: async function () {
    try {
      let res = await axios.get("/setting/" + this.$store.getters.shopKey + "/data.json");
      console.log(res.data);
      this.$store.commit("setSetting", res.data);

      console.log("☆GA");
      if (res.data.analytics) {
        console.log("☆GA 1");
        if (res.data.analytics.ga4) {
          console.log("☆GA 2");
          const ga = document.createElement('script');
          ga.type = 'text/javascript';
          ga.src = 'https://www.googletagmanager.com/gtag/js?id=' + res.data.analytics.ga4;

          const s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(ga, s);
          // console.log("☆GA 3", s, ga.src);
          ga.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', res.data.analytics.ga4);
          }
        }
      }

    } catch (error) {
      console.log(error);
      let errormsg = "";

      if (this.$store.getters.shopKey) {
        errormsg = "【" + this.$store.getters.shopKey + "】は存在しません";
      } else {
        errormsg = "店舗が指定されていません"
      }
      this.$router.push({ name: 'error', query: { "key": this.$store.getters.shopKey }, params: { "errormessage": errormsg } });
      return;
    }

    let localHashKey;
    let newUser = false;
    try {
      localHashKey = localStorage.getItem(this.$store.getters.shopKey + "_key");
      if (!localHashKey) throw new Error("not localHashKey");
    } catch (error) {
      let ukey = this.$store.getters.hashPrefix + Math.floor(Math.random() * 100000) + "_" + (new Date()).getTime() + "_" + navigator.userAgent;
      localHashKey = this.$CryptoJS.SHA256(ukey).toString();
      newUser = true;
      localStorage.setItem(this.$store.getters.shopKey + "_key", localHashKey);
    }

    if (!newUser) {
      try {
        let data = JSON.parse(localStorage.getItem(this.$store.getters.shopKey + "_data"));
        console.log("☆LOCAL DATA", data);
        this.$store.commit("init", data);
      } catch (error) {
        console.log(error);
      }
    }

    this.$store.commit("setLocalUserHashKey", localHashKey);
    this.$router.push({ name: 'top', query: { "key": this.$store.getters.shopKey } });

  },
  methods: {

  },
  computed: {

  }
}
</script>
